import React from "react";
import OperationalDocumentEditor from "../common/OperationalDocumentEditor";
import { CashDocForm } from "./Form";

export function CashDocEdit() {
  return <OperationalDocumentEditor kind="cash" FormComponent={CashDocForm} />;
}
